<template>
    <div>
        <!-- 物流軌跡弹窗 -->
        <el-dialog
          :visible.sync="trackingNumberVisible"
          width="800px"
          :before-close="trackingNumberClose"
          :title="$t('Order.List.Components.TrackingDialog.Tips1')"
          v-if="isPC">
            <div style="max-height: 70vh;overflow-y: scroll;">
              <div class="content" v-if="typeLastLine.number">
                <h3>{{ $t('Order.List.Components.TrackingDialog.TrackingNo') }}. : {{ typeLastLine.number }}</h3>
                <h3 style="margin-bottom: 16px">{{ $t('Order.List.Components.TrackingDialog.LastCarrier') }} : {{ typeLastLine.carrier_en }}</h3>
                <template v-if="typeLastLine.events.length">
                  <div class="timeline">
                    <div class="timeline_item f" v-for="(item, index) in typeLastLine.events" :key="index" >
                      <div class="time">{{item.time_iso | timeHandle}}</div>
                      <div class="dot p-r" :class="{dot_active: index === 0}">
                        <div class="solidLine"></div>
                      </div>
                      <div class="description" :class="{active: index === 0}">{{ item.description }}</div>
                    </div>
                  </div>
                </template>
                <emptyShow v-else></emptyShow>
              </div>
              <div class="content" v-if="typeFirstLine.number">
                <h3>{{ $t('Order.List.Components.TrackingDialog.TrackingNo') }}. : {{ typeFirstLine.number }}</h3>
                <h3 style="margin-bottom: 16px">{{ $t('Order.List.Components.TrackingDialog.FirstCarrier') }} : {{ typeFirstLine.carrier_en }}</h3>
                <template v-if="typeFirstLine.events.length">
                  <div class="timeline">
                    <div class="timeline_item f" v-for="(item, index) in typeFirstLine.events" :key="index" >
                      <div class="time">{{item.time_iso | timeHandle}}</div>
                      <div class="dot p-r" :class="{dot_active: index === 0 && !typeLastLine.type}">
                        <div class="solidLine"></div>
                      </div>
                      <div class="description" :class="{active: index === 0 && !typeLastLine.type}">{{ item.description }}</div>
                    </div>
                  </div>
                </template>
                <emptyShow v-else></emptyShow>
              </div>
              <emptyShow v-if="!typeLastLine.number && !typeFirstLine.number"></emptyShow>
            </div>
        </el-dialog>
        <!-- <van-popup v-model="trackingNumberVisible" closeable v-else>
          <div style="font-size:.4rem;font-weight:bold;margin:1rem 0 .3rem">Logistics tracking information</div>
          <div v-for="channel in trackingTimeLine" :key="channel.number">
            <p v-if="+channel.type === 2">Tracking No. from Last Carrier: {{ channel.number }}</p>
            <p v-else>Tracking No. from First Carrier: {{ typeFirstLine.number }}</p>
            <p style="margin-bottom: 16px">Poste Italiane: {{ channel.carrier_en }}</p>
            <van-steps direction="vertical" :active="0" >
              <van-step v-for="(item, index) in channel.events" :key="index" >
                  <p>{{ item.description }}</p>
                  <p>{{ item.time_iso | timeHandle }}</p>
              </van-step>
          </van-steps>
          </div>
        </van-popup> -->
        <el-drawer
          :visible.sync="trackingNumberVisible"
          direction="rtl"
          size="100%"
          v-else>
          <div style="font-size:.4rem;font-weight:bold;margin:1rem 0 .3rem">{{ $t('Order.List.Components.TrackingDialog.LogisticsTrackingInformation') }}</div>
          <div v-for="channel in trackingTimeLine" :key="channel.number">
            <p v-if="+channel.type === 2">{{ $t('Order.List.Components.TrackingDialog.TrackingNoFromLastCarrier') }}: {{ channel.number }}</p>
            <p v-else>{{ $t('Order.List.Components.TrackingDialog.TrackingNoFromFirstCarrier') }}: {{ typeFirstLine.number }}</p>
            <p style="margin-bottom: 16px">{{ $t('Order.List.Components.TrackingDialog.PosteItaliane') }}: {{ channel.carrier_en }}</p>
            <van-steps direction="vertical" :active="0" >
              <van-step v-for="(item, index) in channel.events" :key="index" >
                  <p>{{ item.description }}</p>
                  <p>{{ item.time_iso | timeHandle }}</p>
              </van-step>
          </van-steps>
          </div>
        </el-drawer>
    </div>
</template>

<script>
import API from '@/api'
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import Step from 'vant/lib/step'
import Steps from 'vant/lib/steps'
import 'vant/lib/step/style'
import 'vant/lib/steps/style'
import dayjs from 'dayjs'
import emptyShow from './emptyLogistics.vue'
export default {
  components: {
    'van-popup': Popup,
    'van-step': Step,
    'van-steps': Steps,
    emptyShow
  },
  filters: {
    timeHandle(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm')
    }
  },
  data() {
    return {
      trackingNumberVisible: false,
      trackingTimeLine: [],
      trackingNumberInfo: {
        trackingNumber: undefined,
        carrierCode: undefined
      }
    }
  },
  computed: {
    // 头程物流
    typeFirstLine() {
      const target = this.trackingTimeLine.find(e => e.type === 1)
      return target || { events: [] }
    },
    // 尾程物流
    typeLastLine() {
      const target = this.trackingTimeLine.find(e => e.type === 2)
      return target || { events: [] }
    }
  },
  methods: {
    show(item) {
      const params = {
        package_number: [item.omsPackId],
        track_number: [item.trackingNumber]
      }
      API.orderLogisticsTrackInfo(params).then(res => {
        this.trackingTimeLine = res.data
        this.trackingNumberVisible = true
        this.setSolidLineHeight()
      }).catch(err => {
        this.$message.error(err.data.message)
      })
    },
    trackingNumberClose() {
      this.trackingNumberInfo = {}
      this.trackingTimeLine = []
      this.trackingNumberVisible = false
    },
    setSolidLineHeight() {
      this.$nextTick(() => {
        // 每行连接实线基础高为36px，每多一行加22px
        const eleArr = document.querySelectorAll('.timeline_item');
        [...eleArr].forEach(e => {
          const clientHeight = e.children[2].clientHeight
          const dotEle = e.children[1]
          let descriptionLine = (clientHeight / 22)
          dotEle.children[0].style.height = `${36 + (descriptionLine - 1) * 22}px`
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.van-popup {
    width: 100%;
}
.content{
  margin-bottom: 30px;
  >h3{
    line-height: 26px;
  }
  .timeline {
    .timeline_item{
      margin-bottom: 24px;
      .time{
        font-size: 14px;
        line-height: 22px;
        width: 140px;
        text-align: right;
      }
      .dot{
        margin: 5px 8px 0 10px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #F5F7F7;
        border: 1px solid #CDD4DD;
        .solidLine {
          width: 2px;
          background-color: #CDD4DD;
          position: absolute;
          top: 10px;
          left: 4px;
          right: 0;
        }
      }
      .description {
        font-size: 14px;
        line-height: 22px;
        width: 350px;
      }
      .active{
        color: #99C41C;
      }
      .dot_active{
        background-color: #99C41C;
        border-color: #99C41C;
      }
    }
    .timeline_item:last-of-type{
      .dot{
        .solidLine{
          display: none;
        }
      }
    }

  }
}
</style>
